import React, { useState, useEffect } from "react";
import { makeStyles, Typography, Grid, Link } from "@material-ui/core/";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { useSelector, useDispatch } from "react-redux";
import loginStyle from "./loginItems.module.css";
import Backdrop from "../../Backdrop";
import Aux from "../../../hoc/Auxilliary";
import logo from "../../../assests/logo-blue.png";
import {
  loginRequest,
  isLoggedInUpdate,
  setErrorMessage,
  SystemSettingsDetails,
} from "../../../reduxSlices/loginSlice";
import Input from "../../Ui/input";
import Button from "../../Ui/Button";
import { isObjectEmpty } from "../../../utils/general";
import SnackBar from "../../SnackBar";
import PasswordRestModal from "../../ForgotPassword";
import localizedStrings from "../../../utils/localize";
import SSOLogin from "./SSOLogin";

const useStyle = makeStyles((theme) => ({
  container: {
    margin: "0",
    padding: "1rem 0",
  },
  itemContainer: {
    margin: "0 auto",
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  logoAvatar: {
    width: "30%",
    height: "auto",
  },
  formControl: {
    display: "flex",
    width: "100%",
    alignItems: "center",
  },
  bottomContainer: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "1rem",
  },
}));

const LoginItems = (props) => {
  const classes = useStyle(props);
  const dispatch = useDispatch();
  const loginRequestData = useSelector(
    (state) => state.loginRequest.loginRequestData,
  );

  const errorMessage = useSelector((state) => state.loginRequest.errorMessage);
  window.localStorage.removeItem("email");
  if (!isObjectEmpty(loginRequestData)) {
    let responseData = loginRequestData;
    window.localStorage.setItem("x-auth-token", responseData.token);
    window.localStorage.setItem("x-auth-fullname", responseData.fullname);
    window.localStorage.setItem("x-auth-contactId", responseData.contactid);
    window.localStorage.setItem("x-auth-email", responseData.emailaddress1);
    window.localStorage.setItem("x-auth-mobile", responseData.mobilephone);
    window.localStorage.setItem("isUserLoggedIn", true);
    dispatch(isLoggedInUpdate(true));
    props.history.push({
      pathname: "/home",
    });
  }
  const dataFetchingStatus = useSelector(
    (state) => state.loginRequest.dataFetchingStatus,
  );

  const systemSettingsData = useSelector(
    (state) => state.loginRequest.systemSettingsData,
  );

  const [loginData, setLoginData] = useState({
    form: {
      email: {
        elementType: "input",
        elementConfig: {
          type: "email",
          label: localizedStrings.login.email,
          autoComplete: "email",
          name: "email",
          required: true,
          autoFocus: true,
          fullWidth: true,
        },
        icon: <MailOutlineIcon style={{ color: "#959595" }} />,
        value: "",
      },
      password: {
        elementType: "input",
        elementConfig: {
          type: "password",
          label: localizedStrings.login.password,
          autoComplete: "current-password",
          name: "password",
          required: true,
          fullWidth: true,
        },
        icon: <LockOutlinedIcon style={{ color: "#959595" }} />,
        value: "",
      },
    },
  });
  const [modalState, setModalState] = useState(false);
  const [enableSytemSetting, setEnableSytemSetting] = useState(false);

  const [showSnackBar, setShowSnackBar] = useState({
    status: false,
    message: "",
  });

  const language = useSelector((state) => state.language.language);
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
    setLoginData((prev) => {
      const newObbj = { ...prev };
      newObbj.form.email.elementConfig.label = localizedStrings.login.email;
      newObbj.form.password.elementConfig.label =
        localizedStrings.login.password;
      return newObbj;
    });
  }, [language]);
  const textFieldChangeHandler = (event) => {
    const formData = { ...loginData.form };
    formData[event.target.name].value = event.target.value.trim();
    setLoginData((prevState) => ({
      ...prevState,
      form: formData,
    }));
  };

  useEffect(() => {
    dispatch(SystemSettingsDetails());
  }, [dispatch]);

  useEffect(() => {
    if (!isObjectEmpty(systemSettingsData).length > 0) {
      setEnableSytemSetting(systemSettingsData.ses_enablebulkinvoice);
    }
  }, [systemSettingsData]);

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      let status = { ...showSnackBar };
      status.status = true;
      status.message = errorMessage.error;
      setShowSnackBar(status);
    }
  }, [errorMessage]);

  const handleSubmit = (event) => {
    event.preventDefault();
    let status = { ...showSnackBar };
    status.status = false;
    setShowSnackBar(status);
    const formData = {};
    for (let formDataIdentifier in loginData.form) {
      formData[formDataIdentifier] = loginData.form[formDataIdentifier].value;
    }
    dispatch(loginRequest(formData));
  };

  let formDataElementArray = [];

  for (let key in loginData.form) {
    formDataElementArray.push({
      id: key,
      config: loginData.form[key],
    });
  }
  const showModal = () => {
    setModalState(true);
  };

  let form = (
    <>
      <form className={classes.form} onSubmit={handleSubmit}>
        {formDataElementArray.map((data, index) => {
          return (
            <Input
              key={index}
              inputType={data.config.elementType}
              elementConfig={data.config.elementConfig}
              value={data.config.value}
              changed={(event) => textFieldChangeHandler(event)}
              icon={data.config.icon}
            />
          );
        })}
        <div className={classes.formControl}>
          <div style={{ flex: 1 }}>
            {/* <Input inputType="checkbox" label="Remember me" /> */}
          </div>
          <Link
            variant="body2"
            style={{ cursor: "pointer", margin: "10px 0px" }}
            onClick={showModal}
          >
            {localizedStrings.login.forgotPassword}?
          </Link>
        </div>
        <Button>{localizedStrings.login.signIn}</Button>
        <Grid container className={classes.bottomContainer}>
          <Typography>
            <span> {localizedStrings.login.registerMessageOne}?</span>
            <Link
              variant="body2"
              style={{ cursor: "pointer", marginLeft: "4px" }}
              onClick={() => {
                props.history.push("/register");
              }}
            >
              {localizedStrings.login.registerMessageTwo}
            </Link>
          </Typography>
        </Grid>

        {enableSytemSetting ? (
          <>
            <hr />
          </>
        ) : (
          <></>
        )}
      </form>
      {enableSytemSetting ? (
        <>
          <SSOLogin props={props} />
        </>
      ) : (
        <></>
      )}
    </>
  );

  const handleClose = () => {
    let status = { ...showSnackBar };
    status.status = false;
    setShowSnackBar(status);
    dispatch(setErrorMessage({}));
  };
  const handleModalClose = () => {
    setModalState(false);
  };

  return (
    <Aux>
      <SnackBar
        open={showSnackBar.status}
        message={showSnackBar.message}
        handleClose={handleClose}
      />
      <PasswordRestModal open={modalState} onClose={handleModalClose} />
      <Backdrop show={dataFetchingStatus} />
      <div className={loginStyle.loginContainer}>
        <div className={loginStyle.loginContent}>
          <div className={classes.logoAvatar}>
            <img src={logo} width="100%" alt="logo" />
          </div>
          <Typography component="h1" variant="h5">
            {localizedStrings.login.signIn}
          </Typography>
          {form}
        </div>
      </div>
    </Aux>
  );
};

export default LoginItems;
